import React from "react";
import { Box, Typography, Select, MenuItem } from "@mui/material";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";

const IntensitySelector = ({ intensity, onChangeIntensity }) => (
  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "16px" }}>
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <FitnessCenterIcon sx={{ marginRight: "8px", color: "#4CAF50" }} />
      <Typography variant="body1">Intensity</Typography>
    </Box>
    <Select value={intensity} onChange={(e) => onChangeIntensity(e.target.value)} sx={{ width: "120px" }}>
      <MenuItem value="Easy">Easy</MenuItem>
      <MenuItem value="Moderate">Moderate</MenuItem>
      <MenuItem value="Intense">Intense</MenuItem>
    </Select>
  </Box>
);

export default IntensitySelector;